module.exports = __webpack_public_path__ + "static/media/gifi4.b718dac5.jpg";